'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
interface AvisoFunilProps {
  variante: 'aviso' | 'erro';
  children: ReactNode;
}
const CLASSES_POR_VARIANTE: Record<AvisoFunilProps['variante'], string> = {
  aviso: 'border-warning-300 bg-warning-50 text-warning-800',
  erro: 'border-error-300 bg-error-50 text-error-700'
};
export const AvisoFunil = t0 => {
  const $ = _c(3);
  const {
    variante,
    children
  } = t0;
  const t1 = `flex items-center justify-between gap-3 rounded-[8px] border border-solid px-4 py-3 text-sm ${CLASSES_POR_VARIANTE[variante]}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};